import React from "react";
import Card from "../../../../componets/Card";
import { SkinInterface } from "../../../../store/roblox/skinsSlice";

const _Details = ({ skin }: { skin: SkinInterface | undefined }) => {
  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Description</h4>
        {skin?.description}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Search text</h4>
        {skin?.search_text}
      </Card>
    </>
  );
}

export default _Details;
